import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProjectsFacade, datePipe, delayedFunctionCall } from '@piqet-angular/data';
import { ImpactDataFormateEnum, reportTitals } from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-full-detail-report',
  templateUrl: './full-detail-report.component.html',
  styleUrls: ['./full-detail-report.component.scss'],
})
export class FullDetailReportComponent implements OnInit, AfterViewInit {
  isTocVisible = false;
  profilePic = './assets/images/defaultProfile.jpg';
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  organizationImage = './assets/images/GlobalWarming.png';
  tocSections: any = [];

  @Input() reportData: any;
  isHideLblMaterialCertification: boolean = false;
  isHideSensitivityAnalysis: boolean = false;
  tableId: number = 6;
  figureId: number = 2;
  reportResource = reportTitals;
  mainProjectName!: string;
  remainingProjectName!: string;
  lifeCycleStageContributionImpactItemsTableId: any;
  lifeCycleStageContributionImpactItemsFigureId: any;
  packagingLevelContributionImpactItemsTableId: any;
  packagingLevelContributionImpactItemsFigureId: any;
  componentContributionItemsTableId: any;
  componentContributionItemsFigureId: any;
  ingredientContributionItemsTableId: any;
  ingredientContributionItemsFigureId: any;
  detailFigureId: any;
  figureIndexList: any = [];
  tableIndexList: any = [];
  firstColumnWidth = 40;
  otherColumnWidth = 0;

  constructor(private reportService: ReportsService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    const componentCount = this.reportData?.materialCertificateImpact?.components?.length || 1;
    this.otherColumnWidth = (100 - this.firstColumnWidth) / componentCount;
  }

  ngAfterViewInit() {
    let elements = document.querySelectorAll('.uniqTableSeq');
    let count = 1;
    for (let i = 0; i < elements.length; i++) {
      elements[i].id = i + 'tableIndex';
      let innerHTML = elements[i].innerHTML;
      let updatedHTML = innerHTML.replace(/#1/g, count.toString());
      elements[i].innerHTML = updatedHTML;
      this.tableIndexList.push(elements[i].innerHTML);
      count++;
    }

    let elementsFigure = document.querySelectorAll('.uniqFigureSeq');
    let chartDesign = document.querySelectorAll('.chartDesign');
    let countFigure = 1;
    for (let i = 0; i < elementsFigure.length; i++) {
      let innerHTML = elementsFigure[i].innerHTML;
      let updatedHTML = innerHTML.replace(/#1/g, countFigure.toString());
      elementsFigure[i].innerHTML = updatedHTML;
      if (!innerHTML.includes('is shown')) {
        // if (!!chartDesign[i]) {
        chartDesign[i]['id'] = countFigure - 1 + 'figureIndex';
        this.figureIndexList.push(elementsFigure[i].innerHTML);
        countFigure++;
        // }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.reportData = changes['reportData'].currentValue;
    this.isHideLblMaterialCertification = this.reportData?.isMaterialCertificationRights;
    this.isHideSensitivityAnalysis = this.reportData?.isSensitivityAnalysisRights;
    if (this.reportData.additionalItems.toLowerCase().includes('4')) {
      this.tableId = 7;
    }
    if (this.reportData.additionalItems.toLowerCase().includes('1')) {
      this.tableId = 6;
    }
    if (
      this.reportData.additionalItems.toLowerCase().includes('4') &&
      this.reportData.additionalItems.toLowerCase().includes('1')
    ) {
      this.tableId = 7;
    }
    this.tocSections = this.getFilteredTocSections();
    this.cd.detectChanges();
    this.getRemainingText();
  }
  getFilteredTocSections() {
    const sections = [
      { id: 'projectDetail', title: 'Project details' },
      {
        id: 'scenarioComparison',
        title: 'Scenario comparison',
        children: [
          { id: 'summaryResultNo', title: 'Summary of results - numbers' },
          { id: 'equivalencyUnits', title: 'Equivalency unit' },
          { id: 'packagingMatrics', title: 'Packaging metrics' },
          {
            id: 'materialCertification',
            title: 'Material certification',
            condition: () => this.isHideLblMaterialCertification, // Add this condition
          },
        ],
      },
      {
        id: 'interpretationResult',
        title: 'Interpretation of results',
        children: [
          { id: 'lifeCycleStages', title: 'Contribution by life cycle stage' },
          {
            id: 'lifeCyclePackagingLevel',
            title: 'Contribution by packaging level',
          },
          {
            id: 'packagingComponent',
            title: 'Contribution by packaging components',
          },
          {
            id: 'packagingIngredient',
            title: 'Contribution by ingredients',
            condition: () => this.reportData?.packageAccountedProductId === 2,
          },
        ],
      },
      { id: 'scenarioDetails', title: 'Scenario details' },
      { id: 'resultsScenario', title: 'Results for scenario' },
      {
        id: 'sensitivityAnalysis',
        title: 'Sensitivity analysis',
        condition: () => this.isHideSensitivityAnalysis, // Add this condition
      },
      // ... rest of the sections remain the same
    ];

    return sections
      .map((section: any) => {
        // Filter children based on their condition
        if (section.children) {
          section.children = section.children.filter(
            (sub: any) => !sub.condition || sub.condition()
          );
        }
        // Return the section only if it meets its condition or has valid children
        return !section.condition ||
          section.condition() ||
          (section.children && section.children.length > 0)
          ? section
          : null;
      })
      .filter(section => section !== null);
  }
  getRemainingText(): string {
    const parts = this.reportData.projectName.split(' - ');
    this.mainProjectName = parts[0];
    if (parts.length > 1) {
      this.remainingProjectName = parts.slice(1).join(' - ');
    }
    return '';
  }

  getFormateDate(date: any) {
    return datePipe(date);
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  toggleToc(eve: any) {
    this.isTocVisible = !this.isTocVisible;
  }
}
